import React from "react";
import Breadcrumb from "../../../../components/Breadcrumb";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import PendingBookings from "./PendingBookings";

const PendingLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Pending Requests" />
      <PendingBookings status={4} />
    </MasterLayout>
  );
};

export default PendingLayout;
